export const axisTypes = ["linear", "logarithmic"];
export const DEFAULT_AXIS_TYPE = "linear";
export const DEFAULT_AXIS_CONFIG = {};
